import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHandshake, FiSearch, FiDollarSign, FiEye } = FiIcons;

const ServicesSection = () => {
  const services = [
    {
      icon: FiHandshake,
      title: "Sell-Side Advisory",
      description: "Comprehensive guidance through every step of your exit process, from preparation to closing.",
      features: ["Exit strategy development", "Deal structuring", "Negotiation support", "Closing coordination"]
    },
    {
      icon: FiSearch,
      title: "Buyer Matching",
      description: "Connect with pre-qualified buyers who understand the HVAC industry and your company's value.",
      features: ["Buyer qualification", "Industry-specific matching", "Multiple buyer options", "Competitive bidding"]
    },
    {
      icon: FiDollarSign,
      title: "Business Valuation",
      description: "Professional valuation services to determine your company's true market value and potential.",
      features: ["Market analysis", "Financial assessment", "Industry comparables", "Value optimization"]
    },
    {
      icon: FiEye,
      title: "Confidential Marketing",
      description: "Discreet marketing that protects your business relationships while attracting serious buyers.",
      features: ["Anonymous listings", "NDA management", "Selective disclosure", "Reputation protection"]
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive solutions designed specifically for HVAC business owners 
            looking to exit successfully and maximize their company's value.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 text-blue-600 rounded-lg">
                    <SafeIcon icon={service.icon} className="w-6 h-6" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                        <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;